import React, { useEffect, useState } from 'react';

import vlastneneEmiseDetail from 'services/akcionar/emise/seznamZakEmisi';
import vlastneneEmiseApi from 'services/akcionar/emise/vlastneneEmise';

export interface IDateLimit {
    od: string;
    do: string;
    ucetniden: string;
}

export const useJinaOsobaIsins = (): [
    boolean,
    React.Dispatch<React.SetStateAction<string | undefined>>,
    (
        | {
              labelcz: string;
              value: string;
          }[]
        | undefined
    )
] => {
    const [dataIsins, setDataIsins] = useState<
        {
            labelcz: string;
            value: string;
        }[]
    >();
    const [isinListLoading, setIsinListLoading] = useState<boolean>(false);
    const [ico, setIco] = useState<string>();

    const getIsins = (idmb: string) => {
        setIsinListLoading(true);
        vlastneneEmiseApi('jmeno:asc', 'cz', idmb, 'E')
            .then(resp => {
                resp[0].idsbj
                    ? vlastneneEmiseDetail(resp[0].idsbj)
                          .then(isins =>
                              setDataIsins(
                                  isins.length
                                      ? isins.map(e => {
                                            return {
                                                labelcz: e.isin,
                                                value: e.isin
                                            };
                                        })
                                      : []
                              )
                          )
                          .finally(() => setIsinListLoading(false))
                    : setIsinListLoading(false);
            })
            .catch(() => setIsinListLoading(false));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    };

    useEffect(() => {
        if (ico) {
            getIsins(ico);
        }
    }, [ico]);

    return [isinListLoading, setIco, dataIsins];
};
